import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

export const fuelStationCreate = createAsyncThunk(
    'fuelStation/fuelStationCreate',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.createFuelStation(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to create Fuel Station');
        }
    }
);

export const fetchFuelStations = createAsyncThunk(
    'fuelStation/fetchFuelStations',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getFuelStationPaginated(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Fuel Stations');
        }
    }
);

export const deleteFuelStation = createAsyncThunk(
    'fuelStation/deleteFuelStation',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.deleteFuelStation(id);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to delete Fuel Station');
        }
    }
);

export const fetchFuelStationDetails = createAsyncThunk(
    'fuelStation/fetchFuelStationDetails',
    async (id, { rejectWithValue }) => {
        try {
            const response = await apiService.getFuelStationDetails(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Fuel Station details');
        }
    }
);

export const updateFuelStation = createAsyncThunk(
    'fuelStation/updateFuelStation',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateFuelStation(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update Fuel Station');
        }
    }
);

export const updateFuelRate = createAsyncThunk(
    'fuelStation/updateFuelRate',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.updateFuelRate(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to update Fuel Rate');
        }
    }
);

export const fetchFuelStationHistory = createAsyncThunk(
    'fuelStation/fetchFuelStationHistory',
    async (params, { rejectWithValue }) => {
        try {
            const response = await apiService.getFuelStationHistory(params);
            return response.data;
        } catch (error) {
            return rejectWithValue(error || 'Failed to fetch Fuel Station history');
        }
    }
);

export const commentOnFuelStation = createAsyncThunk(
    'fuelStation/commentOnFuelStation',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiService.commentOnFuelStation(data);
            return response;
        } catch (error) {
            return rejectWithValue(error || 'Failed to post comment');
        }
    }
);

const initialState = {
    fuelStationCreateLoading: false,
    fuelStationCreateError: null,
    getFuelStationsPaginated: null,
    getFuelStationsLoading: false,
    getFuelStationsError: null,
    deleteFuelStationLoading: false,
    fuelStationDetails: null,
    fuelStationDetailsLoading: false,
    fuelStationUpdateLoading: false,
    fuelStationRateUpdateLoading: false,
    fuelStationHistoryData: [],
    fuelStationHistoryLoading: false,
}

const fuelStationSlice = createSlice({
    name: 'fuelStation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFuelStations.pending, (state) => {
                state.getFuelStationsLoading = true;
            })
            .addCase(fetchFuelStations.fulfilled, (state, action) => {
                state.getFuelStationsLoading = false;
                state.getFuelStationsPaginated = action.payload;
            })
            .addCase(fetchFuelStations.rejected, (state, action) => {
                state.getFuelStationsLoading = false;
                state.getFuelStationsError = action.payload;
            })
            .addCase(fuelStationCreate.pending, (state) => {
                state.fuelStationCreateLoading = true;
            })
            .addCase(fuelStationCreate.fulfilled, (state) => {
                state.fuelStationCreateLoading = false;
            })
            .addCase(fuelStationCreate.rejected, (state) => {
                state.fuelStationCreateLoading = false;
            })
            .addCase(fetchFuelStationDetails.pending, (state) => {
                state.fuelStationDetailsLoading = true;
            })
            .addCase(fetchFuelStationDetails.fulfilled, (state, action) => {
                state.fuelStationDetailsLoading = false;
                state.fuelStationDetails = action.payload;
            })
            .addCase(fetchFuelStationDetails.rejected, (state) => {
                state.fuelStationDetailsLoading = false;
            })
            .addCase(updateFuelStation.pending, (state) => {
                state.fuelStationUpdateLoading = true;
            })
            .addCase(updateFuelStation.fulfilled, (state) => {
                state.fuelStationUpdateLoading = false;
            })
            .addCase(updateFuelStation.rejected, (state) => {
                state.fuelStationUpdateLoading = false;
            })
            .addCase(updateFuelRate.pending, (state) => {
                state.fuelStationRateUpdateLoading = true;
            })
            .addCase(updateFuelRate.fulfilled, (state) => {
                state.fuelStationRateUpdateLoading = false;
            })
            .addCase(updateFuelRate.rejected, (state) => {
                state.fuelStationRateUpdateLoading = false;
            })
            .addCase(fetchFuelStationHistory.pending, (state) => {
                state.fuelStationHistoryLoading = true;
            })
            .addCase(fetchFuelStationHistory.fulfilled, (state, action) => {
                state.fuelStationHistoryLoading = false;
                state.fuelStationHistoryData = action.payload;
            })
            .addCase(fetchFuelStationHistory.rejected, (state) => {
                state.fuelStationHistoryLoading = false;
            })
    },
});

export default fuelStationSlice.reducer;
